import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export class Navbar extends Component {

    render() {
        return (
            <nav className='navbar bg-primary'>
                <Link to="/">
                <h1>
                    <i className={this.props.icon} /> {this.props.title}
                </h1>
                </Link>
                <ul>
                    
                    <li>
                        <Link to="/tools">LinkCheck</Link>
                    </li>
                    <li>
                        <Link to="/SGEN">SGEN</Link>
                    </li>
                </ul>
            </nav>
        )
    }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/layout/Navbar.js